import kr from 'Kr/kr';
import HTMLClass from 'Kr/utils/HTMLClass';
import Cookies from 'Kr/utils/Cookie';
let event = new Event('show_availability');

export default class Availability extends kr.Component {
    init() {
        this._classPrefix = 'av--';
        this._levels = {
            contrast:       'default',
            highlightlinks: 'default',
            fontsize:       'default',
            letterspacing:   'default',
            lineheight:     'default',
            layout:         'default',
        }

        this._steps = {
            contrast: {
                default: 'Kontrast',
                turnover: 'Odwróć kolory',
                dark: 'Ciemny kontrast',
                slightly: 'Lekki kontrast',
                nocolors: 'Brak kolorów'
            },
            highlightlinks: {
                default: 'Podświetlanie linków',
                enable: 'Podświetlanie linków'
            },
            fontsize: {
                default: 'Duży tekst',
                x15: 'Duży tekst',
                x2: 'Duży tekst',
            },
            letterspacing: {
                default: 'Odstępy między tekstem',
                enable: 'Odstępy między tekstem'
            },
            lineheight: {
                default: 'Odstępy między liniami',
                enable: 'Odstępy między liniami'
            },
            layout: {
                default: 'wciśnij aby zmienić układ strony',
                enable: 'Zmienono układ strony'
            },
        }

        this.body = this.app.dom.$html;
        this._cookies = new Cookies('krAvailability');
        this._cookiesDays = 365;
        this.closeSelector = '.jsAvailabilityHide';
        this.buttons = this.$element.querySelectorAll('.availability__button');

        this.bind();
        this.loadCookies();
        this.buttons.forEach(item => {
            this.change(item, false);
            
        });
        this.setClasses();
    }

    bind() {
        this.on('click', this.closeSelector, (target, event) => {
            event.preventDefault();
            this._hide();
        });

        window.addEventListener('show_availability', () => {
            this._show();
        });

        this.on('click', 'button.availability__button', (target, event) => {
            event.preventDefault();
            const action = target.getAttribute('data-action') || null;
            if (action == null) {
                return false;
            }
            
            this.change(target);
            this.setClasses();
            this.setCookies();
        });
        
        document.addEventListener('keyup', (e) => {
            e.preventDefault();
            if (e.altKey && e.key === 'u') {
                if(HTMLClass.hasClass(this.body, 'jsAvailabilityShow')) {
                    this._hide();
                }else {
                    this._show();
                }
            }
            return false;
        }, false);
    }

    change(el, next = true) {
        const action = el.getAttribute('data-action') || null;
        if (action == null) {
            return false;
        }
        this.removeClasses();

        const $text = el.querySelector('[data-bind="text"]');
        const $status = el.querySelector('[data-bind="status"]');

        let activeNumber = 0;
        let activeLevel = this._levels[action];
        if (next) {
            const result = this.getNextOption(action);
            activeLevel = result.activeLevel;
            activeNumber = result.activeNumber;
        } else {
            for (let i in this._steps[action]) {
                if (i == activeLevel) {
                    break;
                }

                activeNumber++;
            }
        }
        $text.innerHTML = this._steps[action][activeLevel];
        this._levels[action] = activeLevel;

        let statusHTML = '';
        
        for (let i = 1; i<=activeNumber; i++) {
            statusHTML+='<span></span>';
        }
        $status.innerHTML = statusHTML;
    }

    getNextOption(action) {
        const level = this._levels[action];
        const step = this._steps[action];

        let isActive = false;
        let stepNumber = 0;
        let activeElement = null;
        let activeText = null;
        
        for (let i in step) {
            if (isActive) {
                activeElement = i;
                break;
            }
            if (i == level) {
                isActive = true;
            }

            stepNumber++;
        }
        if (!isActive || activeElement === null) {
            activeElement = Object.keys(step)[0];
            stepNumber = 0;

        }
        activeText = step[activeElement];

        return {
            activeLevel: activeElement,
            activeNumber: stepNumber
        }
    }

    setClasses() {
        for (let i in this._levels) {
            if (this._levels[i] == 'default') {
                continue;
            }
            const className = `${this._classPrefix}${i}--${this._levels[i]}`;
            if (HTMLClass.hasClass(this.body, className)) {
                continue;
            }
            HTMLClass.addClass(this.body, className);
        }
    }

    removeClasses() {
        for (let i in this._levels) {
            HTMLClass.removeClass(this.body, `${this._classPrefix}${i}--${this._levels[i]}`);
        }
    }

    setCookies() {
        let cookieArray = [];
        for (let i in this._levels) {
            cookieArray.push(`${i}:${this._levels[i]}`);
        }
        const cookie = cookieArray.join('|');
        this._cookies.set(cookie, this._cookiesDays);
    }

    loadCookies() {
        const cookiesString = this._cookies.get();
        if (!cookiesString) {
            return;
        }
        const cookieArray = cookiesString.split('|');
        cookieArray.forEach(item => {
            const cookie = item.split(':');
            this._levels[cookie[0]] = cookie[1];
        });
    }
    
    _hide() {
        HTMLClass.removeClass(this.body, 'jsAvailabilityShow');
    }

    _show() {
        HTMLClass.addClass(this.body, 'jsAvailabilityShow');
        window.setTimeout(() => {
            const $el = this._getButtonByAction('contrast');
            if ($el == null) {
                return;
            }
            $el.focus();
        }, 100);
    }


    _getButtonByAction(action) {
        let element = null;
        this.buttons.forEach(item => {
            if (item.getAttribute('data-action') == action) {
                element = item;
                return;
            }
        });

        return element;
    }
}

kr.registerComponent('#jsAvailability', {
    component: Availability
});

window.showAvailability = function() {
    window.dispatchEvent(event);
    return false;
}